import { SetState } from 'zustand';
import { IBillItem } from '../../../types';
import { getBillById } from '../utils';
import { IBillsHubSlice } from './index';

export interface IModalsSlice {
  showBillDetailsModal: boolean,
  showAccountantSwitcherModal: boolean,
  setShowAccountantSwitcherModal: (showModal: boolean) => void,
  setShowBillDetailsModal: (showModal: boolean) => void,
  selectedBill: IBillItem | null,
  setSelectedBill: (billId: string | null, billItem?: IBillItem) => void;
  billActionsReferenceElement: any;
  setBillActionsReferenceElement: (element: any) => void;
  activeBillModal: string;
  setActiveBillModal: (modalName: string) => void;
  resetModalsSlice: () => void;
}

const modalsSliceInitialState = {
  showBillDetailsModal: false,
  showAccountantSwitcherModal: false,
  selectedBill: null,
  billActionsReferenceElement: null,
  activeBillModal: '',
};

const createModalsSlice = (set: SetState<IBillsHubSlice>) => ({
  showBillDetailsModal: false,
  showAccountantSwitcherModal: false,
  setShowBillDetailsModal: (showModal: boolean) => {
    set({ showBillDetailsModal: showModal });
  },
  setShowAccountantSwitcherModal: (showModal: boolean) => {
    set({ showAccountantSwitcherModal: showModal });
  },
  selectedBill: null,
  setSelectedBill: (billId: string | null, billItem?: IBillItem) => {
    if (billItem) {
      set({ selectedBill: billItem });
    } else if (billId === null) {
      set({ selectedBill: billId });
    } else {
      set((state) => ({ selectedBill: getBillById([...state.unpaidBills, ...state.paidBills], billId) }));
    }
  },
  billActionsReferenceElement: null,
  setBillActionsReferenceElement: (element: any) => set({ billActionsReferenceElement: element }),
  activeBillModal: '',
  setActiveBillModal: (modalName: string) => set({ activeBillModal: modalName }),
  resetModalsSlice: () => {
    set(modalsSliceInitialState);
  },
});

export default createModalsSlice;
